import Bravologo from "../image/bravo.svg"
import Blogimg0 from "../image/blogimg0.png"
import Carousel1 from '../image/carousel1.jpg'
import Carousel2 from '../image/carousel2.jpg'
import Carousel3 from '../image/carousel3.jpg'
import ShoppingGif from "../image/shopping-buy.gif"
import Lengushopping from "../image/lengtu-shopping.gif"

import  Product1 from '../image/product1.jpg'
let Image = {
   Carousel1,
   Carousel2,
   Carousel3,
   Bravologo,
   Blogimg0,
   ShoppingGif,
   Lengushopping,
   Product1
};

export default Image;
